import React, { useCallback } from 'react';
import { Textarea } from '@vectord/components';
import classNames from 'classnames';

import styles from './PlaylistMarkdownInput.module.scss';

function PlaylistMarkdownInput({ value, onChange, className }) {
  const handleOnChange = useCallback(
    (event) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  return (
    <Textarea
      value={value}
      onChange={handleOnChange}
      className={classNames(styles.root, className)}
      placeholder="Please add content in markdown format"
    />
  );
}

export default PlaylistMarkdownInput;
